module.exports = __webpack_public_path__ + "src/assets/games/16/241.jpg";